import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CardsContainerHeaderBaseComponent } from '@resident-nx/shared';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-cards-container-header',
  templateUrl: './cards-container-header.component.html',
  styleUrls: ['./cards-container-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, NgClass, TranslateModule],
})
export class CardsContainerHeaderWebComponent extends CardsContainerHeaderBaseComponent {
  public onTap(): void {
    this.tapped.emit();
  }
}
